// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretUpFilledSvg from "@ant-design/icons-svg/es/asn/CaretUpFilled";
import AntdIcon from '../components/AntdIcon';

var CaretUpFilled = function CaretUpFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretUpFilledSvg
  }));
};

CaretUpFilled.displayName = 'CaretUpFilled';
export default React.forwardRef(CaretUpFilled);